export const isLive = status => !!status && status !== "archived"
